module.exports = __webpack_public_path__ + "img/contact-logo.85751254.png";